module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    key: _vm.operator.definitionId,
    staticClass: "definition-operator operator-icon",
    class: [_vm.levelClass, {
      'cant-drop-here': !_vm.canDropHere,
      'not-editable': _vm.thisPartIsInACountGroup
    }],
    attrs: {
      "disabled": _vm.disableDefinitionPart,
      "draggable": false
    },
    on: {
      "dblclick": function($event) {
        return _vm.editOperator($event)
      },
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler
    }
  }, [_c('svg-icon', {
    class: _vm.operatorConfig.icon.class,
    attrs: {
      "icon": _vm.operatorConfig.icon.svg,
      "width": _vm.operatorConfig.icon.width,
      "height": _vm.operatorConfig.icon.height
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5451db78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/targetDefinition/components/targetDefinitionStatement/DefinitionOperator.vue
// module id = 1904
// module chunks = 0